// extracted by mini-css-extract-plugin
module.exports = {"author__circle":"styles_author__circle__EadgF","author__content":"styles_author__content__Wd7Ii"};